module.exports = __webpack_public_path__ + "static/program-dla-malej-firmy-baner-1503x1080-cf89ce9076caf0aa09770dfc92bc9dcc.png";